import { ERROR_CODES } from '../errors/error-codes';
import { EVENT_CEILING_TIER_DEFINITIONS } from './credit';
export function creditCardState(summary) {
    if (summary.activeContract)
        return 'contract';
    if (summary.available <= 0)
        return 'exhausted';
    if (summary.byKind.single <= 0 && summary.byKind.pack_12 <= 0)
        return 'trialOnly';
    return 'credits';
}
/** Deneme ve standart kademenin katılımcı tavanı (paket tablosundan). */
export const TRIAL_CEILING = EVENT_CEILING_TIER_DEFINITIONS.trial.attendeeCeiling ?? 0;
export const STANDARD_CEILING = EVENT_CEILING_TIER_DEFINITIONS.standard.attendeeCeiling ?? 0;
export function publishDialogState(summary, creditPhase, publishError) {
    if (publishError?.code === ERROR_CODES.CREDIT_EXHAUSTED)
        return 'race';
    if (!summary)
        return creditPhase === 'failed' ? 'credit' : 'loading';
    const next = summary.nextPublish;
    if (next === null)
        return 'exhausted';
    if (next.source === 'contract')
        return 'contract';
    if (next.source === 'trial')
        return 'trial';
    return 'credit';
}
/** Yayın onayında "Yayınla" yerine "Bize ulaş" çizilen hâller (kredi bitti ve yarış). */
export function publishBlockedByCredit(state) {
    return state === 'exhausted' || state === 'race';
}
//# sourceMappingURL=credit-view.js.map